var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-auto"},[_c('router-link',{staticClass:"block px-2 py-1",attrs:{"to":_vm.to}},[_c('i',{staticClass:"fas fa-pen text-sm text-gray-500 hover:text-blue"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }